export default "__VITE_ASSET__CxPeCWEP__"